import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  Link
} from '@customink/pigment-react';
import PigmentNotification from '~/components/PigmentNotification';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function PersonalizationNotSupportedWarning(props) {
  const isMobile = breakpoint(MediaQueries.mediumAndBelow);

  return (
    <PigmentNotification
      {...props}
      width="sm"
      title="Personalization not supported">
      <DialogContent paddingTop="1em" paddingBottom="1em !important">
        <Alert severity="error">
          Any names and numbers will be removed if you continue. The product you
          selected doesn't support personalization.
        </Alert>
      </DialogContent>
      <DialogActions
        direction={isMobile ? 'column' : 'row-reverse'}
        justifyContent="flex-start">
        <Button
          size="large"
          variant="primary"
          onClick={() => props.confirm(true)}
          fullWidth={isMobile}>
          Continue
        </Button>
        <Link href="#/productCatalog">
          <Button
            variant="secondary"
            size="large"
            onClick={props.dismiss}
            fullWidth={isMobile}>
            Choose Another Item
          </Button>
        </Link>
      </DialogActions>
    </PigmentNotification>
  );
}

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func
};

PersonalizationNotSupportedWarning.propTypes = propTypes;

PersonalizationNotSupportedWarning.displayName =
  'PersonalizationNotSupportedWarning';

import {bindActionCreators} from 'redux';
import {confirm} from '~/actions/NotificationActions';

function actions(dispatch) {
  return bindActionCreators(
    {
      confirm
    },
    dispatch
  );
}

import {connect} from 'react-redux';

export default connect(null, actions)(PersonalizationNotSupportedWarning);
